/*
  PAIX-V1 brand helpers (CRO 22/10).
  Size first: no size is chosen in advance, on the product page and in quick add (fewer wrong sizes and returns,
  Baymard). Add to cart (also from the sticky bar) asks for a size instead of adding the first one. A link with
  ?variant= keeps its size. The sticky bar says "choose a size" until one is chosen.
*/
(function () {
  'use strict';
  var B = window.BRAND || {};
  var SIZE = /^(size|størrelse|storrelse|taille|str\.?)$/i;
  var QUICK = 'quick-add-modal, .quick-add-modal, dialog.quick-add';

  function sizeFieldsetIn(root) {
    var sets = (root || document).querySelectorAll('variant-picker fieldset');
    for (var i = 0; i < sets.length; i++) {
      var input = sets[i].querySelector('input[type=radio]');
      var lg = sets[i].querySelector('legend');
      var name = (input && input.getAttribute('data-option-name')) || (lg ? lg.textContent : '');
      if (SIZE.test(String(name).trim())) return sets[i];
    }
    return null;
  }
  function mainRoot() { return document.querySelector('product-information, .product-information') || document; }
  function needsSizeIn(root) {
    var fs = sizeFieldsetIn(root);
    return !!(fs && fs.querySelectorAll('input[type=radio]').length > 1 && !fs.querySelector('input[type=radio]:checked'));
  }
  function uncheck(fs) {
    if (!fs || fs.getAttribute('data-b-size-first')) return;
    var radios = fs.querySelectorAll('input[type=radio]');
    if (radios.length < 2) return;
    fs.setAttribute('data-b-size-first', '1');
    radios.forEach(function (r) { r.checked = false; r.setAttribute('data-current-checked', 'false'); });
    fs.addEventListener('change', function () { clearAsk(fs); stickyText(); });
  }
  function ask(fs) {
    if (!fs) return;
    fs.classList.add('b-size-need');
    var msg = fs.parentNode.querySelector('.b-size-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'b-size-msg';
      msg.setAttribute('role', 'alert');
      fs.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = B.chooseSize || 'Choose your size';
    fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var first = fs.querySelector('input[type=radio]:not([aria-disabled="true"])') || fs.querySelector('input[type=radio]');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
  }
  function clearAsk(fs) {
    if (!fs) return;
    fs.classList.remove('b-size-need');
    var msg = fs.parentNode.querySelector('.b-size-msg');
    if (msg) msg.remove();
  }
  /* Sticky bar: say "choose a size" instead of the first size; give its icon button a name */
  function stickyText() {
    var bar = document.querySelector('sticky-add-to-cart');
    if (!bar) return;
    var v = bar.querySelector('.sticky-add-to-cart__variant');
    if (v && needsSizeIn(mainRoot())) v.textContent = B.chooseSizeShort || B.chooseSize || '';
    var btn = bar.querySelector('.sticky-add-to-cart__button');
    if (btn && !btn.getAttribute('aria-label')) btn.setAttribute('aria-label', B.addToCart || 'Add to cart');
  }

  function rootFor(btn) {
    var q = btn.closest(QUICK);
    if (q) return q;
    return mainRoot();
  }

  function start() {
    var isProduct = /^product/.test(document.body.getAttribute('data-template') || '');
    var keep = /[?&]variant=/.test(location.search);
    if (isProduct && !keep) uncheck(sizeFieldsetIn(mainRoot()));
    if (isProduct) { stickyText(); setTimeout(stickyText, 800); }

    /* Quick add (cards): the picker is rendered into a modal later, so watch for it */
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        document.querySelectorAll(QUICK).forEach(function (m) { uncheck(sizeFieldsetIn(m)); });
      }).observe(document.body, { childList: true, subtree: true });
    }

    var SEL = 'add-to-cart-component button, [ref="addToCartButton"], .sticky-add-to-cart button, .sticky-add-to-cart__button';
    function stop(e) {
      var btn = e.target.closest && e.target.closest(SEL);
      if (!btn) return;
      var root = rootFor(btn);
      if (root === mainRoot() && keep) return;
      if (!needsSizeIn(root)) return;
      e.stopImmediatePropagation();
      if (e.type === 'click') {
        e.preventDefault();
        ask(sizeFieldsetIn(root));
      }
    }
    /* On window in the capture phase, so it runs before Horizon's own handlers (no "added" tick without a size).
       Only the click is cancelled; pointerdown/mousedown are just kept from Horizon so the tap still becomes a click. */
    ['pointerdown', 'mousedown', 'click'].forEach(function (t) { window.addEventListener(t, stop, true); });
    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
      var root = f.closest(QUICK) || mainRoot();
      if (root === mainRoot() && keep) return;
      if (needsSizeIn(root)) { e.preventDefault(); e.stopImmediatePropagation(); ask(sizeFieldsetIn(root)); }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  v2 life (Omar 22/10: "mere animation og mere liv"): reveal on scroll, a gentle parallax on the wall photo, and
  the coin rain on INSERT COIN (Omar's own wish for the arcade). Typing P-A-I-X anywhere also drops coins.
  Everything stands still for visitors who prefer less motion.
*/
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    return pw && pw.scrollHeight > pw.clientHeight + 5 && getComputedStyle(pw).overflowY !== 'visible' ? pw : window;
  }

  /* Reveal on scroll, with a small stagger inside each group */
  function reveal() {
    var auto = document.querySelectorAll('.b-sechead, .b-usps__item, .b-spot__img, .b-spot__copy > *, .b-faq__grid > *, .b-news__grid > *, .product-grid > li, .b-storyp__text > *');
    auto.forEach(function (el) { if (!el.hasAttribute('data-b-reveal')) el.setAttribute('data-b-reveal', ''); });
    var els = document.querySelectorAll('[data-b-reveal]');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.setProperty('--b-d', Math.min(n++ * 0.08, 0.4) + 's');
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Gentle parallax on .b-parallax images */
  function parallax() {
    if (reduce) return;
    var imgs = [].slice.call(document.querySelectorAll('.b-parallax'));
    if (!imgs.length) return;
    var sc = scroller(), ticking = false;
    function run() {
      ticking = false;
      var vh = window.innerHeight;
      imgs.forEach(function (img) {
        var r = img.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.setProperty('--b-par', (p * -40).toFixed(1) + 'px');
      });
    }
    (sc === window ? window : sc).addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* Coin rain */
  function coins(host, count, then) {
    if (reduce) { if (then) then(); return; }
    var box = host || document.body, fixed = !host;
    var layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = (fixed ? 'position:fixed;inset:0;' : 'position:absolute;inset:0;') + 'pointer-events:none;overflow:hidden;z-index:9999';
    box.appendChild(layer);
    var h = fixed ? window.innerHeight : box.getBoundingClientRect().height;
    for (var i = 0; i < count; i++) {
      var c = document.createElement('span');
      c.className = 'b-coin';
      c.style.left = (Math.random() * 96) + '%';
      c.style.setProperty('--d', (0.9 + Math.random() * 0.9).toFixed(2) + 's');
      c.style.setProperty('--fall', (h + 60) + 'px');
      c.style.setProperty('--r', (Math.random() > 0.5 ? '' : '-') + (180 + Math.random() * 540 | 0) + 'deg');
      c.style.animationDelay = (Math.random() * 0.5).toFixed(2) + 's';
      layer.appendChild(c);
    }
    setTimeout(function () { layer.remove(); }, 2200);
    if (then) setTimeout(then, 1100);
  }

  function arcade() {
    document.addEventListener('click', function (e) {
      var ins = e.target.closest && e.target.closest('.b-arcade__insert');
      var play = e.target.closest && e.target.closest('.b-arcade .b-btn--neon');
      if (!ins && !play) return;
      var host = e.target.closest('.b-arcade');
      if (play) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || reduce) return;
        e.preventDefault();
        var href = play.getAttribute('href');
        coins(host, 28, function () { location.href = href; });
      } else {
        coins(host, 28);
      }
    });
    var ins = document.querySelector('.b-arcade__insert');
    if (ins) { ins.setAttribute('role', 'button'); ins.setAttribute('tabindex', '0'); ins.style.cursor = 'pointer';
      ins.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); coins(ins.closest('.b-arcade'), 28); } }); }
    /* Typing P-A-I-X anywhere (not in a field) drops a handful of coins */
    var typed = '';
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      typed = (typed + (e.key || '').toLowerCase()).slice(-4);
      if (typed === 'paix') { typed = ''; coins(null, 40); }
    });
  }

  function start() { reveal(); parallax(); arcade(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Q&A: the topic buttons show only that topic's questions. Without JavaScript the buttons stay hidden and every
   question shows. */
(function () {
  'use strict';
  function start() {
    document.querySelectorAll('[data-b-qa]').forEach(function (root) {
      var bar = root.querySelector('.b-qa__topics');
      if (!bar) return;
      bar.hidden = false;
      var tabs = bar.querySelectorAll('[data-b-qa-topic]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var topic = t.getAttribute('data-b-qa-topic');
          tabs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
          var first = null;
          root.querySelectorAll('.b-qa__item').forEach(function (q) {
            var show = topic === 'all' || q.getAttribute('data-topic') === topic;
            q.hidden = !show;
            if (show && !first) first = q;
          });
          if (first && topic !== 'all') { var d = first.querySelector('details'); if (d) d.open = true; }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* CRO-15 (F-39 in the cart): Danish and French euro amounts read "149,99 €", also in the cart drawer that the
   cart redraws in the browser. English keeps "€149.99". */
(function () {
  'use strict';
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  if (lang === 'en') return;
  var RE = /€\s?(\d{1,3}(?:[.\s  ]\d{3})*,\d{2})/g;
  function fix(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) if (n.nodeValue.indexOf('€') !== -1) list.push(n);
    list.forEach(function (t) { var v = t.nodeValue.replace(RE, '$1 €'); if (v !== t.nodeValue) t.nodeValue = v; });
  }
  function all() { document.querySelectorAll('cart-drawer, .cart-drawer, .cart-page, cart-items-component, .cart-summary, sticky-add-to-cart').forEach(fix); }
  var timer;
  function soon() { clearTimeout(timer); timer = setTimeout(all, 60); }
  function start() {
    all();
    if ('MutationObserver' in window) new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
